<template>
	<ul class="class-menu-container profile-menu-container">
		<span
			:style="'width:' + spanWidth + 'px;left:' + spanPosition + 'px;'"
			class="underline"
		></span>
		<div>
			<li>
				<router-link
					id="community-profile"
					:to="{
						name: 'CommunityProfile',
					}"
					class="classes"
					>Mon profil</router-link
				>
			</li>
			<li>
				<router-link
					id="profile"
					:to="{
						name: 'Profile',
					}"
					class="classes"
					>Mon compte</router-link
				>
			</li>
			<!-- <li v-if="!isSSO">
				<router-link
					id="abonnement"
					:to="{
						name: 'Abonnement',
					}"
					class="classes"
					>Mon abonnement</router-link
				>
			</li> -->
		</div>
	</ul>
	<router-view v-slot="{ Component }">
		<transition name="route" mode="out-in">
			<component class="main-component" :is="Component"></component>
		</transition>
	</router-view>
</template>

<script>
export default {
	components: {},
	data() {
		return {
			resourceWidth: '',
			studentWidth: '',
			docWidth: '',
			resourcePosition: '',
			studentPosition: '',
			docPosition: '',
			spanWidth: '',
			spanPosition: '',
		}
	},
	computed: {
		isSSO() {
			return this.$store.getters.isSSO
		}
	},
	methods: {
		updateSpan(e) {
			// Si l'onglet demandé n'existe pas (ex. Abonnement masqué en SSO), fallback
			if (e === 'Abonnement' && (this.isSSO || !this.abonnementWidth)) {
				// Privilégier Profile, sinon CommunityProfile
				e = this.profileWidth ? 'Profile' : 'CommunityProfile'
			}
			switch (e) {
				case 'CommunityProfile':
					this.spanWidth = this.communityProfileWidth
					this.spanPosition = this.communityProfilePosition
					break
				case 'Profile':
					this.spanWidth = this.profileWidth
					this.spanPosition = this.profilePosition
					break
				case 'Abonnement':
					this.spanWidth = this.abonnementWidth || this.profileWidth || this.communityProfileWidth
					this.spanPosition = this.abonnementPosition ?? this.profilePosition ?? this.communityProfilePosition
					break
			
			}
		},
	},
	mounted() {
		const profile = document.getElementById('profile')
		const abonnement = document.getElementById('abonnement')
		const communityProfile = document.getElementById('community-profile')

		// Largeurs (défensive)
		this.profileWidth = profile ? profile.offsetWidth : 0
		this.abonnementWidth = abonnement ? abonnement.offsetWidth : 0
		this.communityProfileWidth = communityProfile ? communityProfile.offsetWidth : 0

		// Élément de référence pour position
		const refEl = communityProfile || profile || abonnement
		if (refEl) {
			const referenceLeft = refEl.getBoundingClientRect().left
			this.communityProfilePosition = communityProfile ? (communityProfile.getBoundingClientRect().left - referenceLeft) : 0
			this.profilePosition = profile ? (profile.getBoundingClientRect().left - referenceLeft) : 0
			this.abonnementPosition = abonnement ? (abonnement.getBoundingClientRect().left - referenceLeft) : undefined
		}

		// Fallback si la route pointe vers Abonnement mais l'onglet est masqué
		const current = (this.$route.name === 'Abonnement' && (this.isSSO || !abonnement)) ? (profile ? 'Profile' : 'CommunityProfile') : this.$route.name
		this.updateSpan(current)
	},
	watch: {
		$route(to) {
			this.updateSpan(to.name)
		}
	},
}
</script>

<style>
</style>
